import { h } from '@atomify/jsx';

import { BPDFunctionalSvg } from '../svg/svg';

interface TooltipInterface {
    classes?: string;
    icon?: string;
    direction?: 'left' | 'right' | 'top' | 'top-start';
    text: string | Text;
    variant?: 'small';
}

const Tooltip = ({
    classes,
    icon = 'icons-information',
    text,
    variant,
    direction = 'top',
}: TooltipInterface) => (
    <bpd-tooltip
        class={`c-tooltip ${classes ? classes : ''} ${variant ? `tooltip--${variant}` : ''}`}>
        <button class="tooltip__icon" js-hook-tooltip-icon>
            <BPDFunctionalSvg name={icon} />

            <div class={`tooltip__item tooltip__item--${direction}`}>
                <div class="tooltip__content">{text}</div>
            </div>
        </button>
    </bpd-tooltip>
);

export { Tooltip };
